import { render, staticRenderFns } from "./SalaryLockView.vue?vue&type=template&id=8b8c38aa&"
import script from "./SalaryLockView.vue?vue&type=script&lang=js&"
export * from "./SalaryLockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports